"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRules = exports.useRulesDispatch = exports.useRulesState = exports.RulesProvider = exports.initialState = void 0;

var _react = require("react");

var _reducer = require("./reducer");

var _factory = require("../../factory");

const initialState = {
  loadingRules: false,
  rules: undefined,
  ruleList: undefined,
  selectedRule: undefined
};
exports.initialState = initialState;
const stateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const dispatchContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const RulesProvider = (0, _factory.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.RulesProvider = RulesProvider;
const useRulesState = (0, _factory.createStateHook)(stateContext);
exports.useRulesState = useRulesState;
const useRulesDispatch = (0, _factory.createDispatchHook)(dispatchContext);
exports.useRulesDispatch = useRulesDispatch;
const useRules = (0, _factory.createContextHook)(stateContext, dispatchContext);
exports.useRules = useRules;